import { ENV } from "../../constants"; export const defaultEnv: ENV = ENV.PROD;
